// src/components/Hero.js

import React from "react";
import "./Hero.css";
import fotoHero from "../assets/Yvinna-perfil.png"; // Certifique-se de ter uma boa foto da Yvinna aqui
import logoTransparente from "../assets/logo-yvinna.svg"; // Use uma versão PNG transparente da logo

const Hero = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-text">
          <div className="hero-logo-bg">
            <img src={logoTransparente} alt="Logo Yvinna Patrícia" />
          </div>
          <p className="hero-subtitle">
            Consultoria de Imagem, Estilo & Autoestima
          </p>
          <h1>Descubra a elegância que já existe em você</h1>
          <p className="hero-description">
            Com a orientação certa, você vai aprender a se vestir para
            conquistar — mais confiança, presença e autenticidade.
          </p>
          <a href="#contato" className="cta-button">
            Agende sua Análise
          </a>
        </div>
        <div className="hero-image">
          <img src={fotoHero} alt="Yvinna Patrícia" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
